var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.externalLink)?_c('router-link',{staticClass:"link",class:_vm.size,attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.text))]):_c('a',{staticClass:"link",class:_vm.size,attrs:{"href":_vm.to}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }